"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateDraftDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const order_type_enum_1 = require("../orders/order-type.enum");
const origin_app_enum_1 = require("../origin-app.enum");
const utils_1 = require("../utils");
class CreateDraftDto {
}
__decorate([
    (0, class_validator_1.IsDateString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Transform)(({ value }) => (0, utils_1.extractPlainDate)(value)),
    __metadata("design:type", String)
], CreateDraftDto.prototype, "requestedDate", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsIn)(Object.values(order_type_enum_1.OrderType)),
    __metadata("design:type", String)
], CreateDraftDto.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", Array)
], CreateDraftDto.prototype, "lines", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", Boolean)
], CreateDraftDto.prototype, "isSalesRep", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((createDraft) => createDraft.isSalesRep),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], CreateDraftDto.prototype, "contactId", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((createDraft) => !!createDraft.origin),
    (0, class_validator_1.IsIn)(Object.values(origin_app_enum_1.OriginApp)),
    __metadata("design:type", String)
], CreateDraftDto.prototype, "origin", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Length)(12, 13),
    __metadata("design:type", String)
], CreateDraftDto.prototype, "sourceOrderNumber", void 0);
exports.CreateDraftDto = CreateDraftDto;
//# sourceMappingURL=create-draft.dto.js.map